/* SAFI Hijabs — playful interactions.
   1. Soft "bloop" on nav links & buttons (Web Audio, debounced, quiet).
   2. Wishlist heart pulse.
   3. Checkout celebration: brand-color confetti + thank-you flash (<1.5s),
      then the checkout submit proceeds. Fails open: any error submits
      immediately.
   Toggles come from body[data-safi-sounds] / body[data-safi-celebrate]. */
(function () {
  'use strict';

  var body = document.body;
  var soundsOn = body.getAttribute('data-safi-sounds') === 'true';
  var celebrateOn = body.getAttribute('data-safi-celebrate') === 'true';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Web Audio helpers ---------------- */
  function audioCtx() {
    var Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    window.__safiAudioCtx = window.__safiAudioCtx || new Ctor();
    if (window.__safiAudioCtx.state === 'suspended') window.__safiAudioCtx.resume();
    return window.__safiAudioCtx;
  }

  function bloop() {
    // soft high "plink" — quick rise, fast decay
    try {
      var ctx = audioCtx();
      if (!ctx) return;
      var t = ctx.currentTime;
      var osc = ctx.createOscillator();
      var gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.setValueAtTime(900, t);
      osc.frequency.exponentialRampToValueAtTime(1250, t + 0.06);
      gain.gain.setValueAtTime(0.18, t);
      gain.gain.exponentialRampToValueAtTime(0.0001, t + 0.12);
      osc.connect(gain);
      gain.connect(ctx.destination);
      osc.start(t);
      osc.stop(t + 0.14);
    } catch (e) {}
  }

  /* Soft, elegant confetti soundscape: a slow gentle "poof" bloom,
     then a quiet sparkling rain that lasts the whole celebration
     and fades out with the thank-you screen. */
  function celebrationSound(durMs) {
    try {
      var ctx = audioCtx();
      if (!ctx) return;
      var t0 = ctx.currentTime;
      var dur = durMs / 1000;
      var master = ctx.createGain();
      master.gain.value = 0.9;
      master.connect(ctx.destination);

      // 1) slow soft "poof" — low-passed noise blooming over ~1.2s
      var len = Math.floor(ctx.sampleRate * 1.3);
      var buf = ctx.createBuffer(1, len, ctx.sampleRate);
      var d = buf.getChannelData(0);
      for (var i = 0; i < len; i++) d[i] = (Math.random() * 2 - 1) * Math.pow(1 - i / len, 2);
      var poof = ctx.createBufferSource();
      poof.buffer = buf;
      var lp = ctx.createBiquadFilter();
      lp.type = 'lowpass';
      lp.frequency.setValueAtTime(1400, t0);
      lp.frequency.exponentialRampToValueAtTime(320, t0 + 1.2);
      var pg = ctx.createGain();
      pg.gain.setValueAtTime(0.0001, t0);
      pg.gain.exponentialRampToValueAtTime(0.13, t0 + 0.22);
      pg.gain.exponentialRampToValueAtTime(0.0001, t0 + 1.3);
      poof.connect(lp);
      lp.connect(pg);
      pg.connect(master);
      poof.start(t0);

      // 2) confetti-rain bed — very quiet airy shimmer, full duration
      var len2 = Math.floor(ctx.sampleRate * dur);
      var buf2 = ctx.createBuffer(1, len2, ctx.sampleRate);
      var d2 = buf2.getChannelData(0);
      for (i = 0; i < len2; i++) d2[i] = Math.random() * 2 - 1;
      var bed = ctx.createBufferSource();
      bed.buffer = buf2;
      var bp = ctx.createBiquadFilter();
      bp.type = 'bandpass';
      bp.frequency.value = 5400;
      bp.Q.value = 0.9;
      var bg = ctx.createGain();
      bg.gain.setValueAtTime(0.0001, t0);
      bg.gain.linearRampToValueAtTime(0.03, t0 + 0.6);
      bg.gain.setValueAtTime(0.03, t0 + dur - 1.1);
      bg.gain.linearRampToValueAtTime(0.0001, t0 + dur);
      bed.connect(bp);
      bp.connect(bg);
      bg.connect(master);
      bed.start(t0);
      bed.stop(t0 + dur + 0.1);
    } catch (e) {}
  }

  /* ---------------- 1. Link/button bloop ---------------- */
  if (soundsOn) {
    var lastBloop = 0;
    document.addEventListener(
      'click',
      function (e) {
        var el = e.target.closest('a, button, [role="button"]');
        if (!el) return;
        // skip: form fields, checkout (has its own pop), the cat (meows)
        if (el.closest('input, textarea, select, label')) return;
        if (el.getAttribute('name') === 'checkout') return;
        if (el.closest('[data-safi-cat]')) return;
        // skip if the user is selecting text
        var sel = window.getSelection && window.getSelection();
        if (sel && sel.toString().length > 0) return;
        var now = Date.now();
        if (now - lastBloop < 150) return;
        lastBloop = now;
        bloop();
      },
      true
    );
  }

  /* ---------------- 2. Wishlist heart pulse ---------------- */
  document.addEventListener('click', function (e) {
    var heart = e.target.closest('.m-wishlist-button');
    if (!heart || reducedMotion) return;
    heart.classList.remove('safi-heart-pulse');
    void heart.offsetWidth; // restart animation
    heart.classList.add('safi-heart-pulse');
  });

  /* ---------------- Cart icon bump on count change ---------------- */
  if (!reducedMotion && 'MutationObserver' in window) {
    document.querySelectorAll('.m-cart-count-bubble').forEach(function (bubble) {
      var mo = new MutationObserver(function () {
        var icon = bubble.closest('a, button') || bubble.parentElement;
        [bubble, icon].forEach(function (n) {
          if (!n) return;
          n.classList.remove('safi-cart-bump');
          void n.offsetWidth; // restart animation
          n.classList.add('safi-cart-bump');
        });
      });
      mo.observe(bubble, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------------- 3. Checkout celebration ---------------- */
  /* Slow confetti rain: pieces drift from the top of the screen to the
     bottom. Mostly pink, white, and gold — gold pieces shimmer. */
  var CONFETTI_PINKS = ['#F6E4E8', '#EFB7C6', '#E79FB3'];
  var CONFETTI_WHITES = ['#FFFFFF', '#FDF9F5'];

  function confettiRain(duration) {
    var canvas = document.createElement('canvas');
    canvas.className = 'safi-confetti';
    canvas.style.cssText =
      'position:fixed;inset:0;width:100vw;height:100vh;pointer-events:none;z-index:100001;';
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    document.body.appendChild(canvas);
    var ctx2d = canvas.getContext('2d');
    var H = canvas.height;
    var parts = [];
    for (var i = 0; i < 150; i++) {
      var kind = Math.random();
      var p = {
        x: Math.random() * canvas.width,
        // staggered above the viewport so pieces keep arriving
        y: -20 - Math.random() * H * 0.9,
        vy: 2.2 + Math.random() * 2.2, // slow, drifting fall
        swayAmp: 18 + Math.random() * 26,
        swayFreq: 0.5 + Math.random() * 0.9,
        phase: Math.random() * Math.PI * 2,
        size: 5 + Math.random() * 6,
        rot: Math.random() * Math.PI,
        vr: (Math.random() - 0.5) * 0.14,
        circle: Math.random() < 0.3,
        gold: false,
        color: '#fff'
      };
      if (kind < 0.4) {
        p.color = CONFETTI_PINKS[i % CONFETTI_PINKS.length];
      } else if (kind < 0.7) {
        p.color = CONFETTI_WHITES[i % CONFETTI_WHITES.length];
      } else {
        p.gold = true; // shimmering gold
      }
      parts.push(p);
    }
    var start = null;
    function frame(ts) {
      if (!start) start = ts;
      var elapsed = ts - start;
      var progress = elapsed / duration;
      ctx2d.clearRect(0, 0, canvas.width, canvas.height);
      if (progress >= 1) {
        canvas.remove();
        return;
      }
      var t = elapsed / 1000;
      var fade = progress < 0.8 ? 1 : 1 - (progress - 0.8) / 0.2;
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y += p.vy;
        p.rot += p.vr;
        if (p.y > H + 20) continue; // finished its fall
        var x = p.x + Math.sin(t * p.swayFreq * Math.PI * 2 + p.phase) * p.swayAmp;
        var color = p.color;
        var alpha = fade;
        if (p.gold) {
          // shimmer: brightness pulses between deep and pale gold,
          // with a brief bright glint at the top of each pulse
          var s = 0.5 + 0.5 * Math.sin(t * 5 + p.phase * 3);
          var r = Math.round(201 + (247 - 201) * s);
          var g = Math.round(162 + (231 - 162) * s);
          var b = Math.round(75 + (176 - 75) * s);
          color = 'rgb(' + r + ',' + g + ',' + b + ')';
          if (s > 0.94) alpha = Math.min(1, fade + 0.2);
        }
        ctx2d.save();
        ctx2d.globalAlpha = alpha;
        ctx2d.translate(x, p.y);
        ctx2d.rotate(p.rot);
        // flutter: width squeezes as the piece "turns" in the air
        var flutter = 0.35 + 0.65 * Math.abs(Math.sin(t * 3 + p.phase));
        ctx2d.fillStyle = color;
        if (p.circle) {
          ctx2d.beginPath();
          ctx2d.arc(0, 0, (p.size / 2) * flutter + p.size * 0.15, 0, Math.PI * 2);
          ctx2d.fill();
        } else {
          ctx2d.fillRect((-p.size / 2) * flutter, -p.size / 4, p.size * flutter, p.size / 2);
        }
        ctx2d.restore();
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function thankYouFlash(duration) {
    var el = document.createElement('div');
    el.className = 'safi-celebrate';
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<div class="safi-celebrate__inner">' +
      '<p class="safi-celebrate__heading">Thank you for shopping at SAFI Hijabs ✨</p>' +
      '<p class="safi-celebrate__tagline">Elegance in Modesty</p>' +
      '</div>';
    document.body.appendChild(el);
    window.setTimeout(function () {
      el.remove();
    }, duration);
  }

  if (celebrateOn) {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[name="checkout"]');
      if (!btn) return;
      if (btn.dataset.safiCelebrated === '1') return; // second pass: submit normally
      if (reducedMotion) return; // no delay, no flash — straight to checkout
      try {
        e.preventDefault();
        e.stopPropagation();
        btn.dataset.safiCelebrated = '1';
        celebrationSound(2600); // starts just before the confetti falls
        confettiRain(4800);
        thankYouFlash(4600);
        window.setTimeout(function () {
          btn.click(); // native click submits the cart form incl. name=checkout
        }, 4500);
      } catch (err) {
        btn.dataset.safiCelebrated = '1';
        btn.click();
      }
    });
  }
})();
